import * as React from 'react';

import {
    Stack,
    List,
    ListItemButton,
    ListItemIcon,
    ListSubheader,
    Box,
    Avatar,
    ListItem,
    useMediaQuery
} from '@mui/material'
import { Logout } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';


import EmailIcon from '@mui/icons-material/Email';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';



import { BaseComp, BaseContent, TextBody, TextContent, TextTitle, Img, IconBox, OurMission, IconsDiv, } from './styles';
import { Formulario } from './ContactForm';

interface INavBar {

}



const Contact: React.FC<INavBar> = () => {
    const navigate = useNavigate();

    const matches = useMediaQuery('(max-width:800px)');


    return (
        <BaseComp id='contact'>
            <BaseContent>
                <TextContent>
                <TextBody>
                    <TextTitle>
                        <h1>Fale com a gente!</h1>
                        <p>Envie suas sugestões, críticas e elogios a respeito do serviço prestado pelas empresas de transporte público da SetraBH.</p>
                    </TextTitle>
                    <IconsDiv>
                        <IconBox>
                            <EmailIcon style={{ width: matches ? "40px" : "60px" , height: matches ? "40px" : "60px", color: "white" }}/>
                            <p>contato@setrabh.org.br</p>
                        </IconBox>
                        <IconBox>
                            <PhoneEnabledIcon style={{ width: matches ? "40px" : "60px" , height: matches ? "40px" : "60px", color: "white" }}/>
                            <p>(31) 3248-7300</p>
                        </IconBox>
                    </IconsDiv>
                </TextBody>
                <OurMission>
                    <Formulario />
                    
                </OurMission>
                </TextContent>
            </BaseContent>
        </BaseComp>
    );
}

export { Contact }